import React from 'react';
import { DefaultDarkTheme } from '../../themes/default-dark.theme';
import { Page } from '../../components/Page/Page';
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  ThemeProvider,
  Typography,
} from '@mui/material';
import { CommuniqateDarkTheme } from '../../themes/communiqate-dark.theme';
import { MarqtingDarkTheme } from '../../themes/marqting-dark.theme';
import AppLink from '../../components/Link/AppLink';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import Image from 'next/image';
import { COMMUNIQATE_ROUTE, MARQTING_ROUTE } from '../routes';
import { Section } from '../../components/Section/Section';
import { HighLightedText } from '../../components/HighLightedText/HighLightedText';

function IndexPage() {
  return (
    <Page
      theme={DefaultDarkTheme}
      title={'Ontdek de kracht van het ACN Cloud Platform'}
      seo={{
        description:
          'We geven inzicht in online en offline data en vereenvoudigen dit tot puzzelstukken. We helpen strategische keuzes te onderbouwen en garanderen een hoger rendement. Combineer de puzzelstukken binnen ons platform en leg de puzzel in elkaar voor de meertrapsraket in rendementsgroei.',
        openGraph: {
          type: 'website',
          locale: 'nl_NL',
          title:
            'Ontdek de kracht van het ACN Cloud Platform | AppCenter Nederland',
          description:
            'We geven inzicht in online en offline data en vereenvoudigen dit tot puzzelstukken. We helpen strategische keuzes te onderbouwen en garanderen een hoger rendement. Combineer de puzzelstukken binnen ons platform en leg de puzzel in elkaar voor de meertrapsraket in rendementsgroei.',
          images: [
            {
              url: 'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              secureUrl:
                'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/featured_img_home_v2.jpg',
              width: 1920,
              height: 1080,
              alt: 'We geven inzicht in online en offline data en vereenvoudigen dit tot puzzelstukken. We helpen strategische keuzes te onderbouwen en garanderen een hoger rendement. Combineer de puzzelstukken binnen ons platform en leg de puzzel in elkaar voor de meertrapsraket in rendementsgroei.',
              type: 'image/jpeg',
            },
          ],
          site_name: 'AppCenter Nederland',
        },
      }}
    >
      <Section
        position="center"
        caption="Op ons platform bundelen we de kracht van onze producten."
        titleTypographyProps={{ lineHeight: 1.75 }}
        title={
          <>
            <Typography
              component="span"
              fontWeight={500}
              color="inherit"
              fontSize="inherit"
            >
              Ontdek de
            </Typography>{' '}
            <HighLightedText
              TypographyProps={{ color: 'secondary' }}
              text={'kracht'}
            />{' '}
            <Typography
              component="span"
              fontWeight={500}
              color="inherit"
              fontSize="inherit"
            >
              van het
            </Typography>{' '}
            <HighLightedText
              TypographyProps={{ color: 'secondary' }}
              text={'ACN'}
            />{' '}
            <HighLightedText
              TypographyProps={{ color: 'secondary' }}
              text={'Cloud'}
            />{' '}
            <Typography
              component="span"
              fontWeight={500}
              color="inherit"
              fontSize="inherit"
            >
              platform.
            </Typography>
          </>
        }
        subtitle="We geven inzicht in online en offline data en vereenvoudigen dit tot puzzelstukken. We helpen strategische keuzes te onderbouwen en garanderen een hoger rendement. Combineer de puzzelstukken binnen ons platform en leg de puzzel in elkaar voor de meertrapsraket in rendementsgroei.
"
      >
        <Grid container spacing={4}>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Card>
              <ThemeProvider theme={CommuniqateDarkTheme}>
                <CardContent
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <Box mt={4} />
                  <Image
                    src={
                      'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/logo_communiqate_white.svg'
                    }
                    height={60}
                    width={450}
                  />
                  <Box mt={4} />
                  <Typography
                    variant={'h3'}
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      lineHeight: { xs: 2, lg: 1.6 },
                      fontSize: { xs: '2.25rem', lg: '2.5rem' },
                    }}
                    component={'h2'}
                    fontWeight={600}
                  >
                    TIM {''}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'transformeert'}
                    />{' '}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'klantinteractie'}
                    />{' '}
                    op een persoonlijke manier. Dat zorgt voor{' '}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'exponentiële'}
                    />{' '}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'omzetgroei.'}
                    />
                  </Typography>
                  <Box mt={4} />
                  <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      size={'large'}
                      href={COMMUNIQATE_ROUTE}
                      component={AppLink}
                      color="primary"
                      endIcon={<ArrowForwardIcon />}
                    >
                      Ontdek CommuniQate
                    </Button>
                    <Button
                      fullWidth
                      variant={'outlined'}
                      color={'inherit'}
                      size={'large'}
                      startIcon={<WhatsAppIcon />}
                      href="https://wa.me/31850604011?text=Demo%20aanvragen%20CommuniQate%20via%20Website"
                      target={'_blank'}
                    >
                      Demo aanvragen
                    </Button>
                  </Stack>
                </CardContent>
                {/*<Box*/}
                {/*  sx={{*/}
                {/*    display: 'flex',*/}
                {/*    justifyContent: 'center',*/}
                {/*    position: 'relative',*/}
                {/*    height: 500,*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <Box*/}
                {/*    component={'img'}*/}
                {/*    sx={{ position: 'absolute', bottom: -60 }}*/}
                {/*    height={400}*/}
                {/*    src={*/}
                {/*      'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/kracht_van_tim.svg'*/}
                {/*    }*/}
                {/*  />*/}
                {/*</Box>*/}
              </ThemeProvider>
            </Card>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
            <Card>
              <ThemeProvider theme={MarqtingDarkTheme}>
                <CardContent
                  sx={{
                    textAlign: 'center',
                  }}
                >
                  <Box mt={2.8} />
                  <Image
                    src={
                      'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/marqting_logo_white.svg'
                    }
                    height={70}
                    width={400}
                  />
                  <Box mt={4} />
                  <Typography
                    variant={'h3'}
                    sx={{
                      color: 'white',
                      textAlign: 'center',
                      lineHeight: { xs: 2, lg: 1.6 },
                      fontSize: { xs: '2.25rem', lg: '2.5rem' },
                    }}
                    component={'h2'}
                    fontWeight={600}
                  >
                    Maakt de offline wereld {''}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'meetbaar.'}
                    />{' '}
                    Dat zorgt voor {''}
                    betere beslissingen en {''}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'meer'}
                    />{' '}
                    <HighLightedText
                      TypographyProps={{ color: 'primary' }}
                      text={'rendement.'}
                    />
                  </Typography>
                  <Box mt={4} />
                  <Stack direction={{ xs: 'column', lg: 'row' }} spacing={2}>
                    <Button
                      fullWidth
                      variant="contained"
                      size={'large'}
                      href={MARQTING_ROUTE}
                      component={AppLink}
                      color="primary"
                      endIcon={<ArrowForwardIcon />}
                    >
                      Ontdek MarQting
                    </Button>
                    <Button
                      fullWidth
                      variant={'outlined'}
                      color={'inherit'}
                      size={'large'}
                      startIcon={<WhatsAppIcon />}
                      href="https://wa.me/31850604011?text=Demo%20aanvragen%20MarQting%20via%20Website"
                      target={'_blank'}
                    >
                      Demo aanvragen
                    </Button>
                  </Stack>
                </CardContent>
                {/*<Box*/}
                {/*  sx={{*/}
                {/*    display: 'flex',*/}
                {/*    justifyContent: 'center',*/}
                {/*    position: 'relative',*/}
                {/*    height: 500,*/}
                {/*  }}*/}
                {/*>*/}
                {/*  <Box*/}
                {/*    component={'img'}*/}
                {/*    sx={{ position: 'absolute', bottom: -60 }}*/}
                {/*    height={400}*/}
                {/*    src={*/}
                {/*      'https://appcenternederland-general.ams3.cdn.digitaloceanspaces.com/appcenternederland-website/marqting_hero_image.svg'*/}
                {/*    }*/}
                {/*  />*/}
                {/*</Box>*/}
              </ThemeProvider>
            </Card>
          </Grid>
        </Grid>
      </Section>
    </Page>
  );
}

export default IndexPage;
